var map = {
	"./blackGold/fragments/arrow_down.png": 51847,
	"./brownGold/fragments/arrow_down.png": 89300,
	"./darkBlue/fragments/arrow_down.png": 82342,
	"./greenYellow/fragments/arrow_down.png": 9654,
	"./redGold/fragments/arrow_down.png": 56990,
	"./skyBlue/fragments/arrow_down.png": 48413,
	"./whiteGold/fragments/arrow_down.png": 30977,
	"./yellowWhite/fragments/arrow_down.png": 80774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69641;